<template>
  <div class="flex flex-col min-h-full" dir="ltr">
    <div
      class="text-h1 pb-4"
      ref="titleRef"
      :style="titleOffset ? `padding-start: ${titleOffset}px` : ''"
    >
      {{ $t("Legal.commercialName") }}
    </div>
    <div class="grid md:grid-cols-2 md:gap-x-4 md:justify-center gap-4">
      <div class="flex justify-center items-center">
        <contact-details ref="contactDetailsRef" />
      </div>
      <div class="flex justify-center items-center">
        <legal-details class="mt-4 md:mt-0" />
      </div>
    </div>
    <div class="mt-8 grid place-items-center">
      <p class="text-sm">{{ $t("Legal.trademarkNotice") }}</p>
      <p class="text-sm">{{ $t("Legal.copyrightNotice", { currentYear }) }}</p>
    </div>
  </div>
</template>

<script>
import ContactDetails from "@/components/legal/ContactDetails.vue";
import LegalDetails from "@/components/legal/LegalDetails.vue";

export default {
  components: {
    ContactDetails,
    LegalDetails,
  },
  data() {
    return {
      titleOffset: 0,
    };
  },
  mounted() {
    const titleOffset = this.$refs.titleRef.offsetLeft;
    const contactDetailsOffset = this.$refs.contactDetailsRef.$el.offsetLeft;
    this.titleOffset = contactDetailsOffset - titleOffset;
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
